import { render, staticRenderFns } from "./Years.vue?vue&type=template&id=68a97af0&scoped=true"
import script from "./Years.vue?vue&type=script&lang=js"
export * from "./Years.vue?vue&type=script&lang=js"
import style0 from "./Years.vue?vue&type=style&index=0&id=68a97af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a97af0",
  null
  
)

export default component.exports